import React, { useContext } from "react";
import "./Map.scss";
import { authContext } from "../../../Context/Authentication/authContext";
declare const google: any;

const Map = ({ cityPredictions, stateCord ,geoData,zipCode}: any) => {
   const { dispatch, state }: any = useContext(authContext);
  React.useEffect(() => {
    const map = new google.maps.Map(document.getElementById("predictionsGoogleMap"), {
      zoom: 6,
      center: new google.maps.LatLng(
        parseInt( state.filters.stateCord.coOrd
          ? state.filters.stateCord.coOrd.lat
          : state.filters.stateCord.lat),
        parseInt(state.filters.stateCord.coOrd
          ? state.filters.stateCord.coOrd.lng: state.filters.stateCord.lng)
      ),
      mapTypeControl: false,
      mapTypeId: "hybrid",
      streetViewControl: true,
    });

    new google.maps.Marker({
      position: stateCord,
      map,
      scaledSize: new google.maps.Size(35, 35), // scaled size
    });
    if(zipCode){
      if (Object.keys(geoData).length) {
        const poly = geoData[zipCode]
        if (poly) {
          map.data.addGeoJson(poly, `zip-${zipCode}`)
          let obj=cityPredictions.find((city:any)=>city.zipCode===zipCode)
          console.log(obj)

          const latitude = obj.lat
          const longitude = obj.lng
          const centerCoordinates = new google.maps.LatLng(latitude, longitude);
          map.setCenter(centerCoordinates);
          map.setZoom(10);
        }
      }
    }
    for (let i = 0; i < cityPredictions?.length; i++) {
      const myLatLng = {
        lat: cityPredictions[i]?.latitude
          ? Number(cityPredictions[i].latitude)
          : 37.6597307,
        lng: cityPredictions[i]?.longitude
          ? Number(cityPredictions[i].longitude)
          : -121.8975718,
      };
    }
  }, [cityPredictions, stateCord,zipCode]);
  return <div id="predictionsGoogleMap"></div>;
};

export default Map;